import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SamparkEolDeviceAddPageComponent } from './sampark-eol-device-add-page.component';

const routes: Routes = [
  {
    path: 'sampark-eol-device-add-page',
    data: { name: 'Production - Device', isTab: false },
    component: SamparkEolDeviceAddPageComponent,
  },
  {
    path: 'sampark-eol-device-add-page/:id',
    component: SamparkEolDeviceAddPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SamparkEolDeviceAddPageRoutingModule {}
